import { Fragment } from "react";

import { FormControl, TextField } from '@mui/material'

import CustomFormLabel from './CustomFormLabel.js'

export default function CustomInputForm({ DataForm = [{}], FormName = '', isMobileView }) {
    const st_DefaultInputProps = { fontFamily: 'Montserrat, Segoe UI', fontSize: isMobileView ? '16px' : '1.2vw' }
    const st_Default = { width: '100%', margin: '1% 0 1% 0', border: '0px solid red' }

    return (
        <Fragment>
            {DataForm.map((item, index) => {
                const Label = item.Label
                const isRequired = item.isRequired ? true : false
                const Type = item.Type
                const Name = item.Name
                const Value = item.Value
                const Action = item.Action
                const Placeholder = item.Placeholder
                const SelectOption = item.SelectOption
                const Comparison = item.Comparison
                return (
                    <Fragment
                        key={`${FormName}_${index}`}
                    >
                        {Type === "Password" ?
                            <Fragment></Fragment>
                            : Type === "Select" ?
                                <Fragment>
                                    {!SelectOption ?
                                        <h1>No Select Option, OBJ = Value:'', Display:''</h1>
                                        : <Fragment></Fragment>}
                                </Fragment>
                                : Type === "Number" ?
                                    <Fragment></Fragment>
                                    : Type === "Document" ?
                                        <Fragment>
                                            <CustomFormLabel
                                                Label={Label ? Label : '-'}
                                                isRequired={isRequired}
                                                Type='Document'
                                                DocAva={Comparison}
                                            />
                                            {/* <input type='file' accept='application/pdf' onChange={this.File_OnChange} name='CV' required={OldCV ? false : true} /> */}
                                            <TextField
                                                type="file"
                                                placeholder={Placeholder ? Placeholder : ''}
                                                name={Name ? Name : ''}
                                                // value={Value ? Value : ''}
                                                required={isRequired ? Comparison ? false : true : true}
                                                onChange={Action ? Action : () => null}
                                                style={st_Default}
                                                // label={Label ? Label : '-'}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    accept: "application/pdf",
                                                }}
                                                variant="outlined"
                                            />
                                        </Fragment>
                                        : <Fragment>
                                            <CustomFormLabel
                                                Label={Label ? Label : '-'}
                                                isRequired={isRequired}
                                            />
                                            <TextField
                                                type={Type ? Type : 'text'}
                                                placeholder={Placeholder ? Placeholder : ''}
                                                name={Name ? Name : ''}
                                                value={Value ? Value : ''}
                                                required={isRequired}
                                                onChange={Action ? Action : () => null}
                                                style={st_Default}
                                                InputProps={{
                                                    style: st_DefaultInputProps
                                                }}
                                            /><br /><br />
                                        </Fragment>
                        }
                    </Fragment>
                )
            })}

        </Fragment >
    )
}